export const CLEAN = 'CLEAN';
export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_FAILED = 'ME_FAILED';

export const AUTH_LOADING = 'AUTH_LOADING';
